import { render, staticRenderFns } from "./AlipayRefund.vue?vue&type=template&id=0cd9e78e&scoped=true&"
import script from "./AlipayRefund.vue?vue&type=script&lang=js&"
export * from "./AlipayRefund.vue?vue&type=script&lang=js&"
import style0 from "./AlipayRefund.vue?vue&type=style&index=0&id=0cd9e78e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9e78e",
  null
  
)

export default component.exports